import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UnleashProxyService } from '@shared/services/unleash-proxy.service';

import { AuthGuardService } from './auth-guard.service';

export const featureFlagGuard: CanActivateFn = route => {
  const router = inject(Router);
  const unleashService = inject(UnleashProxyService);
  const authGuardService = inject(AuthGuardService);

  const hasPermission = route.routeConfig?.data?.['permissions']?.some(permission =>
    authGuardService.checkPermission(permission)
  );
  const featureName = route.routeConfig?.data?.['featureName'];
  if (!featureName || !hasPermission) return true;

  const enabled = unleashService.isEnabled(featureName) || hasPermission;
  if (!enabled) {
    router.navigateByUrl('/');
    return false;
  }

  return true;
};
